module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1087.fd01795f.jpg";